import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	autoplayLabel: {
		id: 'company-hub.carousel-extension.config-panel.styles.autoplay-label',
		defaultMessage: 'Autoplay',
		description:
			'A visible text label for the carousel autoplay section of the carousel config panel that informs the user that they can turn autoplay on or off.',
	},
	autoplayTooltipContent: {
		id: 'company-hub.carousel-extension.config-panel.styles.autoplay-tooltip-content',
		defaultMessage: 'Set your carousel to scroll automatically every {number} seconds in view mode',
		description:
			'Tooltip content displayed on hover of information icon providing more details on autoplay toggle.',
	},
});
